// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as ThemeContext$PrezzeeRibbon from "../../../context/ThemeContext/ThemeContext.bs.js";

function themeIconStyles(theme) {
  var match = theme.components;
  return BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.backgroundColor(match.uniqueSellingPoints.iconColor)]);
}

var wrapper = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.alignItems("center"),
      BsCssJs$PrezzeeRibbon.fontWeight("medium")
    ]);

var text = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.flexBasis("auto"),
      BsCssJs$PrezzeeRibbon.flexGrow(1),
      BsCssJs$PrezzeeRibbon.flexShrink(1),
      BsCssJs$PrezzeeRibbon.lineHeight({
            NAME: "abs",
            VAL: 1.5
          }),
      BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.em(2)),
      BsCssJs$PrezzeeRibbon.position("relative")
    ]);

var icon = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("inlineBlock"),
      BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.em(0.6875)),
      BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.em(0.6875)),
      BsCssJs$PrezzeeRibbon.transform(BsCssJs$PrezzeeRibbon.rotate(BsCssJs$PrezzeeRibbon.deg(45))),
      BsCssJs$PrezzeeRibbon.position("absolute"),
      BsCssJs$PrezzeeRibbon.left("zero"),
      BsCssJs$PrezzeeRibbon.top(BsCssJs$PrezzeeRibbon.em(0.5))
    ]);

var Styles = {
  themeIconStyles: themeIconStyles,
  wrapper: wrapper,
  text: text,
  icon: icon
};

function UniqueSellingPoints__ListItem(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  var theme = ThemeContext$PrezzeeRibbon.useTheme(undefined);
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("span", {
                            className: Classnames([
                                  icon,
                                  themeIconStyles(theme)
                                ])
                          }),
                      JsxRuntime.jsx("span", {
                            children: props.children
                          })
                    ],
                    className: text
                  }),
              className: Classnames([
                    wrapper,
                    className$1
                  ])
            });
}

var make = UniqueSellingPoints__ListItem;

export {
  Styles ,
  make ,
}
/* wrapper Not a pure module */
